// extracted by mini-css-extract-plugin
export var container = "social-shares-module--container--nTY9-";